import React, { createContext, useContext, useState } from "react";
import { getDict, LANGS } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  // Locked to German (Tedesco) per business requirement (Wertia Finanz, Swiss German market)
  const [lang] = useState("de");
  const setLang = () => { /* locked */ };
  const t = getDict("de");
  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
